// extracted by mini-css-extract-plugin
export default {"alignment-control":"alignment-control_alignment-control__OjZGy","label":"alignment-control_label__S1sHx","selected":"alignment-control_selected__6Hd5r"};